<template>
  <SAuthLayout>
    <v-col v-if="!isMobile" class="ma-0 pa-0">
      <SAuthSide>
        <div class="d-flex flex-column ma-5">
          <div class="text-h4 font-weight-bold font-italic white--text mb-5">
            Gérer vos capteurs en 1 clic 😉 !
          </div>
          <div class="text-subtitle-1 white--text">
            Détecter les locaux ou la qualité de l'air est un risque pour votre
            personnel - vos administrés - vos clients ! Nous réduisons ainsi les
            risques de propagation des virus et bactéries à l'intérieur de vos
            immeubles.
          </div>
        </div>
      </SAuthSide>
    </v-col>
    <v-col class="ma-0 pa-0">
      <RegisterForm />
    </v-col>
  </SAuthLayout>
</template>

<script>
import SAuthLayout from "@/views/authentification/SAuthLayout";
import RegisterForm from "@/components/authentification/RegisterForm";

export default {
  name: "Register",
  data: () => ({}),
  components: {
    SAuthLayout,
    RegisterForm,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 600;
    },
  },
};
</script>

<style scoped></style>
